































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { LoadingState } from '@/entities/LoadingState';
import ShoppingCartActions from '@/components/shopping-cart/ShoppingCartActions.vue';
import { PartSearchResultDetails } from '@/entities/PartSearchResultDetails';
import Price from '@/components/price/Price.vue';
import { QuickSearchModuleTypes } from '@/store/modules/quick-search';
import SmoothReflow from '@/components/smooth-reflow/SmoothReflow.vue';
import BaseMixin from '@/mixins/BaseMixin';
import URI from 'urijs';
import DeliveryTimeToolTip from '@/components/delivery-time-tooltip/DeliveryTimeToolTip.vue';
import _ from 'lodash';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import { VinSearchResult } from '@/entities/vin-search/VinSearchResult';

@Component({
    components: {
        ShoppingCartActions,
        Price,
        SmoothReflow,
        DeliveryTimeToolTip,
        LoadingIndicator,
    },
})
export default class QuickSearchResult extends Mixins(BaseMixin) {
    @Prop({ type: String })
    private detailSearchLink!: string;
    @Prop({ type: String })
    private catalogueSearchLink!: string;
    @Prop({ type: String })
    private partDetailLink!: string;

    private reloadAvailabilityDebouncedMap: Map<string, (quantity: number, partId: string) => void> = new Map();
    private showAvailabilityMap: Map<string, boolean> = new Map();

    private closeResults(): void {
        this.$store.dispatch(QuickSearchModuleTypes.actions.closeQuickSearchResults);
    }

    private get searchTerm(): string {
        return this.$store.getters[QuickSearchModuleTypes.getters.searchTerm];
    }

    private get isVinSearchResult(): boolean {
        return this.$store.getters[QuickSearchModuleTypes.getters.isVinSearchResult];
    }

    private get partSearchResults(): PartSearchResultDetails[] {
        return this.$store.getters[QuickSearchModuleTypes.getters.partSearchResults];
    }

    private get totalNumberOfResults(): number {
        return this.$store.getters[QuickSearchModuleTypes.getters.totalNumberOfParts];
    }

    private get vinSearchResult(): VinSearchResult {
        return this.$store.getters[QuickSearchModuleTypes.getters.vinSearchResult];
    }

    private get showSearchResults(): boolean {
        return (
            this.$store.getters[QuickSearchModuleTypes.getters.searchResultsLoadingState] === LoadingState.Loaded &&
            this.$store.getters[QuickSearchModuleTypes.getters.totalNumberOfParts] !== -1
        );
    }

    private partDetailLinkForPart(part: PartSearchResultDetails): string {
        return `${this.partDetailLink}${"?id="}${encodeURIComponent(part.searchResult.id)}`;
    }

    private get detailSearchLinkForSearchTerm(): string {
        return new URI(this.detailSearchLink).addQuery({ searchTerm: this.searchTerm }).toString();
    }

    private get catalogueSearchLinkForSearchTerm(): string {
        return new URI(this.catalogueSearchLink).addQuery({ searchTerm: this.searchTerm }).toString();
    }

    private get showNoResultsFound(): boolean {
        return (
            (!this.isVinSearchResult && this.partSearchResults && this.partSearchResults.length === 0) ||
            (this.isVinSearchResult && !this.vinSearchResult)
        );
    }

    private get showGoToDetailsSearch(): boolean {
        return !this.isVinSearchResult;
    }

    private get showNumbers(): boolean {
        return !this.isVinSearchResult;
    }

    @Watch('partSearchResults')
    private updateAvailabilityDebouncedMap(): void {
        this.reloadAvailabilityDebouncedMap.clear();
        this.showAvailabilityMap.clear();
        this.partSearchResults.forEach((result) => {
            const reloadAvailabilityDebounced = _.debounce(this.reloadAvailability, 500);
            this.reloadAvailabilityDebouncedMap.set(result.searchResult.id, reloadAvailabilityDebounced);
            this.showAvailabilityMap.set(result.searchResult.id, true);
        });
    }

    private onQuantityChanged(quantity: number, partId: string): void {
        const reloadAvailabilityDebounced = this.reloadAvailabilityDebouncedMap.get(partId);
        if (reloadAvailabilityDebounced) {
            reloadAvailabilityDebounced(quantity, partId);
        }
    }

    private onQuantityValid(partId: string): void {
        this.showAvailabilityMap.set(partId, true);
        this.showAvailabilityMap = new Map(this.showAvailabilityMap);
    }

    private onQuantityInvalid(partId: string): void {
        this.showAvailabilityMap.set(partId, false);
        this.showAvailabilityMap = new Map(this.showAvailabilityMap);
    }

    private reloadAvailability(quantity: number, partId: string): void {
        this.$store.dispatch(QuickSearchModuleTypes.actions.reloadPartAvailabilityForPart, {
            partId,
            quantity,
        });
    }

    private maxAllowedQuantity(result: PartSearchResultDetails): number | undefined {
        if (!result.searchResult.isUsedPart) {
            return undefined;
        }

        return this.getAvailableItemCount(result);
    }

    private getAvailableItemCount(result: PartSearchResultDetails): number {
        if (!result.partAvailability || !result.partAvailability.stockInfos) {
            return 0;
        }
        return result.partAvailability.stockInfos
            .map((info) => info.quantity)
            .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    }
}
